import strings from "global/constants/StringConstants";
import OneDriveIcon from "assets/icons/onedrive.svg";
import GoogleDriveIcon from "assets/icons/google-drive.png";
import DropboxIcon from "assets/icons/dropbox.svg";
import BoxIcon from "assets/icons/box-storage.svg";
import { CloudProvider } from "./types";

export const cloudProviders: CloudProvider[] = [
  {
    key: strings.ONEDRIVE,
    displayName: "OneDrive",
    icon: OneDriveIcon,
    supportsFolders: true,
  },
];

export const disabledProviders: CloudProvider[] = [
  {
    key: strings.GOOGLE_DRIVE,
    displayName: "Google Drive",
    icon: GoogleDriveIcon,
    supportsFolders: false,
  },
  {
    key: strings.DROPBOX,
    displayName: "Dropbox",
    icon: DropboxIcon,
    supportsFolders: true,
  },
  {
    key: strings.BOX,
    displayName: "Box",
    icon: BoxIcon,
    supportsFolders: true,
  },
];

export const getProviderByKey = (key: string): CloudProvider | undefined =>
  cloudProviders.find((p) => p.key === key);
